import React from 'react';
import { Head } from '@inertiajs/react';
import { Button } from '~/marketing/ui';
import { routes } from '~/marketing/routes';
import { withMarketingLayout } from '~/marketing/MarketingLayout';

/* Render with a 404 status. **The number, one sentence and a way home**, the
   founder's call 2026-10-26. It listed four pages under "Where you probably
   meant to go" and explained that reports are reached only from their email:
   but nothing here knows where somebody meant to go or how they arrived, so
   the links were guesses and the explanation answered one way of arriving
   among many.

   The number is the largest display size, the home page headline's: tried at
   200px and then 96px, and both were too large. */
export default function NotFound() {
  return (
    <>
      <Head title="Not found"><meta name="robots" content="noindex" /></Head>
      <main className="sp-page sp-grid-bg" style={{ paddingBlock: 'clamp(64px,9vw,128px)', display: 'grid', gap: 'var(--space-8)', justifyItems: 'start' }}>
        <span
          className="sp-mono"
          style={{ fontSize: 'var(--fs-display-1)', lineHeight: 1, fontWeight: 'var(--fw-medium)', color: 'var(--text-strong)', letterSpacing: '-0.04em' }}
        >
          404
        </span>
        <h1 style={{ fontSize: 'var(--fs-h2)', lineHeight: 1.2 }}>There is no page at this address.</h1>
        <Button size="lg" href={routes.home}>Go to the home page</Button>
      </main>
    </>
  );
}

NotFound.layout = withMarketingLayout;
